import { Component } from "react";
import {
	DKInput,
	DKButton,
	DKIcons,
	INPUT_VIEW_DIRECTION,
	showAlert,
	showLoader,
	removeLoader,
} from "deskera-ui-library";
import { APP_NAME, INPUT_TYPE } from "../../constants/Constant";
import UserPermissionService from "./UserPermissionService";
import Utility from "../../utility/Utility";

interface InviteUserProps {
	defaultRole?: any;
	canInvite?: boolean;
	allowRoleAdd?: boolean;
	isLoading?: boolean;
	invites?: any;
	fetchInvites?: () => {};
}

interface InviteUserState {
	selectedRoleId: any;
	inviteEmail?: any;
	inviteTapped?: any;
}

class InviteUser extends Component<InviteUserProps, InviteUserState> {
	roles = [];

	constructor(props: InviteUserProps) {
		super(props);
		this.state = {
			inviteEmail: "",
			selectedRoleId: this.props.defaultRole || null,
			inviteTapped: false,
		};
	}

	componentWillReceiveProps(nextProps: InviteUserProps) {
		this.setState({
			selectedRoleId: nextProps.defaultRole || null,
		});
	}

	render() {
		return (
			<div className="row parent-width border-radius-s align-items-end">
				{this.getInputSection()}
				<div className="display-flex row-responsive width-auto justify-content-start align-items-end position-relative">
					{this.getRoleSelectorSection()}
					{this.getInviteButton()}
				</div>
			</div>
		);
	}

	getInputSection() {
		return (
			<DKInput
				title="Add user with email"
				type={INPUT_TYPE.EMAIL}
				direction={INPUT_VIEW_DIRECTION.VERTICAL}
				required={true}
				autoComplete="off"
				value={this.state.inviteEmail}
				canValidate={this.state.inviteTapped}
				errorMessage="Please enter a valid email address"
				onChange={(text: string) => {
					this.setState({ inviteEmail: text });
				}}
			/>
		);
	}

	getRoleSelectorSection() {
		return (
			<div className="column p-h-s">
				<DKButton
					title={"Guest User"}
					className={`text-gray border-m`}
                    style={{
                        padding: "9px"
                    }}
					disabled={true}
					icon={DKIcons.ic_arrow_down2}
					isReverse={true}
					onClick={() => {}}
				/>
			</div>
		);
	}

	getInviteButton() {
		return (
			<DKButton
				title="Invite"
				className="bg-button text-white fw-m"
                style={{
                    padding: "10px 12px"
                }}
				onClick={() => {
					this.onInvite();
				}}
			/>
		);
	}

	onInvite = () => {
		if (!this.props.canInvite) {
			showAlert(
				"Operation not allowed!",
				"You don't have permission to invite users, please contact your organization owner."
			);
			return;
		}

		const { inviteEmail } = this.state;
		if (Utility.isEmpty(inviteEmail) || !Utility.isValidEmail(inviteEmail)) {
			this.setState({ inviteTapped: true });
		} else {
			const payload = {
				appName: APP_NAME,
				email: inviteEmail,
				role: "USER",
			};

			if (this.checkDuplicateEmail(inviteEmail)) {
				showAlert("User Exists!", "User with same email already exists in this organization");
				return;
			}

			showLoader("Inviting user...");
			UserPermissionService.inviteUser(payload).then(
				(response) => {
					removeLoader();
					showAlert(
						`Invitation sent!`,
						`Invitation has been sent to <strong>${inviteEmail}</strong>. Please ask user to check the mail inbox for invitation email and accept it.`
					);
					this.setState({ inviteEmail: "" }, () => this.forceUpdate());
					this.props.fetchInvites();
				},
				(error) => {
					removeLoader();
					if (error?.code === 403) {
						showAlert(
							`Not Allowed!`,
							`Looks like you are not authorize to invite user please contact your organization owner.`
						);
					}
				}
			);
		}
	};

	checkDuplicateEmail = (email) => {
		return this.props.invites?.some((invite) => invite?.email === email?.trim());
	};
}

export default InviteUser;
